import Vue from "vue";
import VueRouter from 'vue-router'

import viewHome from "@/views/viewHome.vue";
import viewProcess from "@/views/viewProcess.vue";
import viewTech from "@/views/viewTech.vue";
import view404 from "@/views/view404.vue";
import viewRetrospectiveWeeklyForm from "@/views/viewRetrospectiveWeeklyForm.vue";

Vue.use(VueRouter)

const routes = [
    { path: '/', component: viewHome },
    { path: '/process', component: viewProcess },
    { path: '/tech', component: viewTech },
    {
        path: '/retrospective-weekly-form',
        component: viewRetrospectiveWeeklyForm,
        name: 'retrospective-weekly-form',
    },
    { path: '*', component: view404 }
];

const router = new VueRouter({
    mode: "history",
    // base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const metaTag = document.querySelector('meta[name="robots"]');
    if (to.name !== 'retrospective-weekly-form') {
        metaTag.setAttribute("content", "index, follow");
    } else {
        metaTag.setAttribute("content", "noindex, nofollow");
        const password = prompt("Please enter password:");
        if (password === "hello") {
            next();
        } else {
            next({ path: '/' })
        }
    }
    next();
});

export default router;
